import React from 'react';

import colors from '@front/common/src/utils/colors';
import { formatPercentage, formatPrice } from '@front/common/src/utils/formatting';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';

const t = translate('basket.membership.card');

type HasMembershipProps = {
  hasPrestationsSelected: boolean;
  reduction: number;
  membershipReductionsPercentage: number;
};

const HasMembership = ({ reduction, hasPrestationsSelected, membershipReductionsPercentage }: HasMembershipProps) => (
  <span>
    <Text.SMMedium>{t('.wellness.is_member.text_1')}</Text.SMMedium>
    <Text.SMBold color={colors.pink120}>
      {` ${hasPrestationsSelected ? formatPrice(reduction) : formatPercentage(membershipReductionsPercentage)} `}
    </Text.SMBold>
    <Text.SMMedium>{t('.wellness.is_member.text_2')}</Text.SMMedium>
  </span>
);

export default HasMembership;
